import { immerable } from 'immer';
import type { TaxonDTO } from '../taxon';

export class Taxon {
  [immerable] = true; // To make it works with immer and produce

  _id = '';
  _key = '';
  children: Taxon[] = [];
  count = 0;
  name = '';
  total_delivery_spend_target_currency = 0;
  total_volume_metric_system = 0;
  total_volume_packs = 0;

  constructor(taxonDTO?: Partial<TaxonDTO>) {
    Object.assign(this, taxonDTO);

    if (taxonDTO?.children?.length) {
      this.children = taxonDTO.children.map(t => new Taxon(t));
    }
  }

  findTaxonByKey(key: string): Taxon | undefined {
    if (this._key === key) {
      return this;
    }

    for (const child of this.children) {
      const taxon = child.findTaxonByKey(key);
      if (taxon) {
        return taxon;
      }
    }

    return undefined;
  }

  findTaxonWhereChildKeyIs(key: string): Taxon | undefined {
    for (const child of this.children) {
      if (child._key === key) {
        return this;
      }

      const taxon = child.findTaxonWhereChildKeyIs(key);

      if (taxon) {
        return taxon;
      }
    }

    return undefined;
  }

  get isLevel0() {
    return this._key[this._key.length - 1] === '0';
  }
}
